import React from "react";
import { makeStyles, Typography, Drawer, FormGroup, FormControlLabel, FormControl, Grid, IconButton, Button } from "@material-ui/core";
import CloseIcon from "../icons/CloseIcon";
import CustomCheckbox from "./CustomCheckbox";
import translate from '../other/translate.json';
import ChevronIcon from "../icons/ChevronIcon";

export default function SubFilterListVers3(props) {
  
  const language = localStorage.getItem('language') || 'Ru'
  const classes = useStyles();
  const [toggleDrawer, setToggleDrawer] = React.useState(false);
  // const [ids, setIds] = React.useState('');

  let { data, setBefore, ids, key1, key2 } = props


  const buileForrender = data.map((item, index) => {
      return (
        <FormGroup aria-label="position" row style={{ marginTop: 12 }}>
          <Grid
            className={classes.list}
            item
            container
            direction="column"
            justify="flex-start"
            alignItems="stretch"
            style={{ zIndex: '999' }}
          >
            <Grid
              item
              container
              direction="row"
              justify="space-between"
              alignItems="center"
            >
              <FormControlLabel
                control={<CustomCheckbox checked={ids && ids.length > 0 && ids.some(el => el[key1] ===item[key1] )} onChange={()=>  setBefore(item)} />}
                label={item[`${key2}`]}
                className={classes.FClabel}
              />

              {/* <IconButton onClick={() => toggleFilterDrawer()} aria-label="filter" className={classes.btnFilter} style={{ padding: 8 }}>
              <ChevronIcon fill='#BCBBD0' />
            </IconButton> */}
              {/* 
            <Drawer // тут информация 
              anchor="right"
              open={infoCadrVisible}
              onClose={() => toggleFilterDrawer(false)}
              onOpen={() => toggleFilterDrawer(true)}
              variant='persistent'
            > */}
              {/* <SectionInfoDrawer close={toggleFilterDrawer} /> */}
              {/* </Drawer> */}
            </Grid>
          </Grid>
        </FormGroup>
      )
  })

  return (
    <React.Fragment>
      <Button
        className={classes.btnSelectFilter}
        endIcon={<ChevronIcon fill={'#BCBBD0'} />}
        onClick={() => {if(!toggleDrawer && !!props.onOpen){props.onOpen()};setToggleDrawer(!toggleDrawer)}}
      >
        {translate.Words[`All${language}`]}
      </Button>

      {data.length > 0 ?
        <Drawer
          anchor="right"
          open={toggleDrawer}
          onClose={() => {toggleDrawer(false); if (!!props.onClose){props.onClose()}}}
          onOpen={() => {toggleDrawer(true); /*if (!!props.onOpen){props.onOpen()*/}}
          variant='persistent'
        >
          <Grid
            container
            direction="column"
            justify="flex-start"
            className={classes.root}
            style={{ /* width: 334 */ overflow: 'auto', height: '100%' }}
          >
            <Grid item className={classes.FilterHeaderCntr} /* style={{ width: 334 }} */ >
              <Grid container direction="row" justify="space-between" alignItems="center" style={{ padding: '12px 12px 12px 24px' }} /* style={{ position: 'fixed', width: 334, background: '#FFF', paddingTop: 32, paddingLeft: 24, zIndex: 2 }} */>
                <Grid item container>
                  <Grid item className={classes.btnForvard}>
                    <IconButton onClick={() => {setToggleDrawer(false); if (!!props.onClose){props.onClose()}}} aria-label="filter">
                      <ChevronIcon fill='#BCBBD0' />
                    </IconButton>
                  </Grid>

                  <Grid item className={classes.btnClose}>
                    <IconButton onClick={() => {setToggleDrawer(false); if (!!props.onClose){props.onClose()}}} aria-label="filter">
                      <CloseIcon fill='#BCBBD0' />
                    </IconButton>
                  </Grid>
                </Grid>

                <Grid item container style={{ paddingTop: 48 }}>
                  <Grid item>
                    <Typography className={classes.filterHeader}>
                      {props.header}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid style={{ height: 'calc(100% - 128px)', overflowX: 'hidden', overflowY: 'auto', scrollbarWidth: 'thin' }}>
              <Grid item container direction="column" style={{ padding: '0 24px', height: '100%' }}>
                <Grid item container direction="column" className={classes.FilterBodyCntr}>
                  <FormControl component="fieldset" style={{ marginTop: 17 }} >
                    {buileForrender}
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>

            {/* <Grid item container style={{ position: 'fixed', bottom: 0, maxWidth: 286 }}>
              <Button variant="contained" className={classes.btnPrimary} onClick={() => props.close()}>{translate.Words[`GoWith${language}`]}</Button>
            </Grid> */}
          </Grid>
        </Drawer>
        :
        ''
      }
    </React.Fragment>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    padding: 0,
  },

  list: {
    width: 286,
  },

  listHeader: {
    fontWeight: 500,
    fontSize: '24px',
    lineHeight: '32px',
    color: '#24262A'
  },

  header: {
    fontWeight: 500,
    fontSize: '24px',
    lineHeight: '32px',
    color: '#24262A'
  },

  formControl: {
    // height: 40,
    marginRight: 0
  },

  label: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    color: '#8987A2',
    paddingLeft: theme.spacing(1),
  },

  btnClose: {
    position: 'absolute',
    right: 12,
    top: 12,
  },

  btnForvard: {
    position: 'absolute',
    left: 12,
    top: 12,
    transform: 'rotate(180deg)'
  },

  btnPrimary: {
    width: '100%',
    background: '#EB505E',
    fontSize: '18px',
    fontWeight: 500,
    lineHeight: '23px',
    color: '#FFFFFF',
    height: 55,
    borderRadius: 48,
    boxShadow: '4px 4px 20px rgba(68, 113, 209, 0.12)',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#EB505E',
      borderColor: '#EB505E',
      boxShadow: 'none',
    },
    '&:focus': {
      background: '#EB505E',
      // boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
    },
  },

  btnSelectFilter: {
    paddingLeft: theme.spacing(2),
    background: '#F6F6FB',
    color: '#8987A2',
    fontSize: 16,
    lineHeight: '36px',
    fontWeight: 400,
    textTransform: 'none',
    justifyContent: 'space-between',
    marginTop: 17,
    width: '100%',
    paddingRight: 20
  },

  filterHeader: {
    fontWeight: 500,
    fontSize: '24px',
    lineHeight: '32px',
    color: '#24262A'
  },

  FilterBodyCntr: {
    // height: 'calc(100% - 75px)',
    height: '100%',
    overflowX: 'hidden',
    overflowY: 'auto',
    //width: 285,
    width: 291,
    flexFlow: 'column',
    scrollbarWidth: 'thin',
    padding: '0 2px'
  },

  FClabel: {
    fontFamily: 'Cera CY',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#8987A2'
  }
}));

